import mediaHelper from './styled-media-helper';
import { BreakPoint, width } from './hooks/use-client-screen-size';

const media = mediaHelper(width);

// const media1080 = media.down('1080');
// const media1280 = media.between('1280', '1600');
const media1080 = media.down('1600');
const media1280 = media.down('1600');
const media1600 = media.between('1600', '1920');
const media1920 = media.up('1920');

const mediaDown1280 = media.down('1280');
const mediaDown1600 = media.down('1600');

const height1080 = 1148;

const media1080Y = `@media (min-height: ${height1080}px) and (max-width:${width['1280'] - 0.02}px)`;

// @media (min-height: 1147px) and (max-width: 1147px)

// export default media;
export {
  media,
  media1080,
  media1280,
  media1600,
  media1920,
  mediaDown1280,
  mediaDown1600,
  media1080Y,
  width,
};
